import request from '@/utils/request'
// 修改密码
export const editPassword = (data: any) =>
  request({
    'url': '/employee/editPassword',
    'method': 'put',
    data
  })
// 获取营业状态（需传当前商户 storeId）
export const getStatus = (params?: { storeId?: string | number }) =>
  request({
    'url': `/shop/status`,
    'method': 'get',
    params,
  })
// 设置用户端打烊/营业强制覆盖（兼容旧逻辑）
export const setStatus = (status: number, params?: { storeId?: string | number }) =>
  request({
    url: `/shop/${status}`,
    method: 'put',
    params,
  })
/** 营业时段 + 模式配置 */
export const getShopOpenConfig = (params: { storeId: string | number }) =>
  request({
    url: '/shop/openConfig',
    method: 'get',
    params,
  })
export const saveShopOpenConfig = (data: {
  storeId: string | number
  openMode: number
  businessOpenTime: string
  businessCloseTime: string
}) =>
  request({
    url: '/shop/openConfig',
    method: 'put',
    data,
  })
